import React, { useState, useEffect } from 'react';
import axios from 'axios';
import Stock_Moving_Details from './Stock_Moving_Details';

const Stock_Moving_Dist = ({ month, year, stock_status }) => {
    const [data, setData] = useState([]);
    const [loading, setLoading] = useState(true);
    const [details, setDetails] = useState(null);

    useEffect(() => {
        setDetails(null); 
    }, [month, year, stock_status]);

    useEffect(() => {
        if (!month || !year || !stock_status) return;

        setLoading(true);
        axios.get(`${process.env.REACT_APP_URL}/api/stock/districtdetails`, {
            params: { month, year, stock_status }
        })
        .then(res => {
            setData(res.data);
            setLoading(false);
        })
        .catch(err => {
            console.error("Error fetching district data:", err);
            setLoading(false);
        });
    }, [month, year, stock_status]); 

    const loadDetails = (dist_code, afso_code) => {
        setDetails({ dist_code, office_code: afso_code, month, year, stock_status });
    };

    if (loading) {
        return (
            <div style={{ textAlign: 'center', margin: '20px' }}>
                <img src="src/images/progress.gif" alt="loading" />
            </div>
        );
    }

    if (data.length === 0) {
        return <div className="mainhead" style={{ textAlign: 'center', margin: '20px' }}>No Data Found</div>;
    }

    return (
        <div style={{ margin: '20px' }}>
            <table 
                style={{ 
                    width: '70%', 
                    margin: '0 auto', 
                    borderCollapse: 'collapse', 
                    border: '1px solid #ddd' 
                }}
            >
                <thead>
                    <tr class="tableheader">
                        <th>Sl No</th>
                        <th>District</th>
                        <th>Office</th>
                        <th>Total FPS</th>
                    </tr>
                </thead>
                <tbody>
                    {data.map((row, i) => (
                        <tr key={`${row.distCode}-${i}`}>
                            <td style={{ textAlign: 'left' }}>{i + 1}</td>
                            <td style={{ textAlign: 'left' }}>{row.distNameEn}</td>
                            <td style={{ textAlign: 'left' }}>{row.afsoNameEn}</td>
                            <td style={{ textAlign: 'right' }}>
                                <a 
                                    style={{ cursor: 'pointer',  textDecoration: 'underline' }}
                                    onClick={() => loadDetails(row.distCode, row.afsoCode)}
                                >
                                    {row.fpsCount}
                                </a>
                            </td>
                        </tr>
                    ))}
                </tbody>
            </table>

            {/* Render details only if details state is set */}
            {details && (
                <div style={{ marginTop: '20px' }}>
                    <Stock_Moving_Details {...details} />
                </div>
            )}
        </div>
    );
};

export default Stock_Moving_Dist;